import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import { GerlRejectCode } from '#models/Gerl.model';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const gerlNotFoundMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/Gerl$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'Gerl',
        statusCode: ControllerStatus.MANUAL_CHECK_REQUIRED,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          controlData: {
            companyId: '113',
            rejectCode: GerlRejectCode.ACCOUNT_NOT_FOUND,
          },
          expirationDateTime: '2999-09-26T00:00:00.000Z',
        },
      } satisfies ControllerDetails,
    },
  },
];
